<template>
  <div class="miya-dashboard">
    <el-alert title="为给客户提供更快的速度体验，内部线路带宽升级，静态中转代理更新，手机使用需要重新扫码，电脑使用需要重新复制导入，带来不便请谅解。" type="warning" />
    <el-scrollbar style="height:100%;">
      <div class="pageBox">
        <h1 class="title1 fontSH">{{$t('dashboard.title1')}}</h1>
        <div class="totalList">
          <div class="card-box">
            <div class="title2">
              <img class="img" src="@assets/images/home/price-icon1.png">
              <span class="titleString fontWeight">{{$t('dashboard.titleCountry')}}</span>
              <el-button class="goPage" type="info" size="mini" @click="$router.push('proxyCountry')">{{$t('dashboard.proxyBtn')}} <i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </div>
            <div class="card">            
              <div class="echart2">
                <div id="echart1"></div>
                <img class="img" src="@assets/images/dynamic/circle.png">
                <p class="value"><miya-number :dataValue="countryList[0].value"></miya-number></p>
                <p class="name">{{countryList[0].name}}</p>
              </div>
              <div class="dataList">
                <div class="item-box">
                  <div class="item">
                    <p class="value"><miya-number :dataValue="countryList[1].value"></miya-number></p>
                    <p class="name">{{countryList[1].name}}</p>
                  </div>
                  <div class="item">
                    <p class="value"><miya-number :dataValue="countryList[2].value"></miya-number></p>
                    <p class="name">{{countryList[2].name}}</p>
                  </div>
                </div>              
                <div class="btn-box">
                  <miya-btn ref="miyaBtn1" @click="clickBuy('country')" :title="$t('dashboard.buyBtn')" class="btn"></miya-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="card-box">
            <div class="title2">
              <img class="img" src="@assets/images/home/price-icon2.png">
              <span class="titleString">{{$t('dashboard.titleCity')}}</span>
              <el-button class="goPage" type="info" size="mini" @click="$router.push('proxyCity')">{{$t('dashboard.proxyBtn')}} <i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </div>
            <div class="card">           
              <div class="echart2">
                <div id="echart2"></div>
                <img class="img" src="@assets/images/dynamic/circle.png">
                <p class="value"><miya-number :dataValue="cityList[0].value"></miya-number></p>
                <p class="name">{{cityList[0].name}}</p>
              </div>
              <div class="dataList">
                <div class="item-box">
                  <div class="item">
                    <p class="value"><miya-number :dataValue="cityList[1].value"></miya-number></p>
                    <p class="name">{{cityList[1].name}}</p>
                  </div>
                  <div class="item">
                    <p class="value"><miya-number :dataValue="cityList[2].value"></miya-number></p>
                    <p class="name">{{cityList[2].name}}</p>
                  </div>
                </div>              
                <div class="btn-box">
                  <miya-btn ref="miyaBtn1" @click="clickBuy('city')" :title="$t('dashboard.buyBtn')" class="btn"></miya-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="subtitle1"><span>{{$t('dashboard.subtitle1')}}</span><label class="time">{{time}}</label></p>
        <div class="echar-box">
          <div class="data-box">
            <div class="time-box"><p>TIME</p><p class="time">{{echartTime}}</p></div>
            <p class="data">{{echartData}}</p>
            <p class="unit">[{{echartUnit}}]</p>
          </div>
          <div class="echart1" id="echart3" v-loading="loadLineData">
            <div class="empty" v-if="!loadLineData">
              <img class="nodata" src="@/assets/images/home/noData.png" alt="" />
              <p class="nodataText">{{$t('home.noData')}}</p>
            </div>          
          </div>
        </div>
        <h1 class="title1 fontSH">{{$t('dashboard.title2')}}</h1>
        <div class="list-box">
          <div class="top-total">
            <div class="item" v-for="(item, idx) in tableTotal" :key="'right-total'+idx">
              <i class="icon"></i>
              <div class="right-text">
                <span class="name">{{item.name}}</span>
                <p class="value">
                  <miya-number :dataValue="item.value"></miya-number><span class="unit">[{{$t('dashboard.orders')}}]</span>
                </p>
              </div>
            </div>
          </div>
          <div class="bottom-table">
            <p class="subtitle1 subtitle2-box">
              <span>{{$t('dashboard.subtitle2')}}</span>
              <el-button class="more" type="primary" @click="$router.push('/purchasedDetails')" size="mini" plain >{{$t('dashboard.more')}} <i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </p>
            <el-table :data="tableData" v-loading="tableLoading" class="tableData">
              <el-table-column prop="qr" :label="$t('dashboard.s5qr')" min-width="110">
                <template slot-scope="scope">
                  <el-popover
                    placement="bottom-start"
                    title=""
                    width="134"
                    trigger="hover"
                    content=""
                    @show="showQrCode(scope.row)">
                    <div class="qrcode" slot="reference">
                      <span>{{$t('dashboard.s5qr')}}</span>
                    </div>
                    <div class="miya-dashboard-qr-img-box">
                      <div :id="`QRImg${scope.row.id}`" :ref="`QRImg${scope.row.id}`"></div>
                    </div>    
                  </el-popover>              
                </template>
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('dashboard.expirationTime')" min-width="90">
                <template slot-scope="scope">
                  <p v-html="getTime(scope.row.createTime)"></p>
                </template>
              </el-table-column>
              <el-table-column prop="type" :label="$t('dashboard.typeString')" min-width="80">
                <template slot-scope="scope">
                  <!-- <p class="type-name">{{$t('home.pTitle3')}}</p> -->
                  <div class="value-box">
                    <!-- <label>{{$t('home.pSubtitile4')}}</label> -->
                    <label v-if="scope.row.mealType === 3" class="type">{{$t('pAgent.type1')}}</label>
                    <label v-if="scope.row.mealType === 4" class="type">{{$t('pAgent.type2')}}</label>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="proxy" :label="$t('pAgent.t1')" min-width="110">
                <template slot-scope="scope">
                  <div class="s5TextBox">
                    <span>{{scope.row.origins5Proxy}}</span>
                    <div class="copyeBtnBox">
                      <el-button type="primary" size="mini" class="copyBtn" :class="'copyBtn1'+scope.row.id" :data-clipboard-text="scope.row.origins5Proxy" @click="clickCopye(`copyBtn1${scope.row.id}`)">{{$t('pCountry.copy')}}</el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="proxy" :label="$t('pAgent.t2')" min-width="110">
                <template slot-scope="scope">
                  <div class="s5TextBox">
                    <span>{{scope.row.originhttpProxy}}</span>
                    <div class="copyeBtnBox">
                      <el-button type="primary" size="mini" class="copyBtn" :class="'copyBtn4'+scope.row.id" :data-clipboard-text="scope.row.originhttpProxy" @click="clickCopye(`copyBtn4${scope.row.id}`)">{{$t('pCountry.copy')}}</el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="proxy" :label="$t('pAgent.t3')" min-width="110">
                <template slot-scope="scope">
                  <div class="s5TextBox">
                    <span>{{scope.row.s5Proxy}}</span>
                    <div class="copyeBtnBox">
                      <el-button type="primary" size="mini" class="copyBtn" :class="'copyBtn2'+scope.row.id" :data-clipboard-text="scope.row.s5Proxy" @click="clickCopye(`copyBtn2${scope.row.id}`)">{{$t('pCountry.copy')}}</el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="proxy" :label="$t('pAgent.t4')" min-width="110">
                <template slot-scope="scope">
                  <div class="s5TextBox">
                    <span>{{scope.row.httpProxy}}</span>
                    <div class="copyeBtnBox">
                      <el-button type="primary" size="mini" class="copyBtn" :class="'copyBtn3'+scope.row.id" :data-clipboard-text="scope.row.httpProxy" @click="clickCopye(`copyBtn3${scope.row.id}`)">{{$t('pCountry.copy')}}</el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <div slot="empty" class="table_nodata">
                <img v-if="!tableLoading" class="nodata" src="@/assets/images/home/noData.png" height="240" alt="" />
                <p v-if="!tableLoading" class="nodataText">{{$t('home.noData')}}</p>
              </div>
            </el-table>
          </div>
        </div>
      </div> 
    </el-scrollbar>
  </div>
</template>
<script>
import miyaNumber from '@components/miyaNumber.vue'
import miyaBtn from '@components/miyaBtn.vue'
import * as echarts from 'echarts'
import moment from 'moment'
import QRCode from 'qrcodejs2';
import { Base64 } from 'js-base64'
export default {
  data () {
    return {
      countryList: [
        {name: '', value: 0},
        {name: '', value: 0},
        {name: '', value: 0},
      ],
      cityList: [
        {name: '', value: 0},
        {name: '', value: 0},
        {name: '', value: 0},
      ],
      echartTime: '00:00',
      echartData: '0',
      echartUnit: 'Mb',
      time: `[ ${moment().format('YYYY-MM-DD')} 00:00-24:00 ]`,
      echart1: null,
      echart2: null,
      echart3: null,
      tableLoading: false,
      tableData: [],
      tableTotal: [
        {name: '', value: 0},
        {name: '', value: 0},
        {name: '', value: 0},
      ],
      loadLineData: false,
    }
  },
  mounted () {    
    // this.$alert('由于服务器升级，近期如您遇到网站访问不了的情况，请访问www.miyaip.net进行代替\nDue to server upgrades, if you encounter a situation where you cannot access the website recently, please visit www.miyaip.net instead.', {
    //       confirmButtonText: '确定',
    //       callback: action => {
    //       }
    //     });
    this.getData()
    this.showEchart3()
    this.showEchart1()
    this.showEchart2()
    this.initEvent()
  },
  methods: {
    getData () {
      this.countryList[0].name = this.cityList[0].name = this.$t('dashboard.dataName1')
      this.countryList[1].name = this.cityList[1].name = this.$t('dashboard.dataName2')
      this.countryList[2].name = this.cityList[2].name = this.$t('dashboard.dataName3')
      this.tableTotal[0].name = this.$t('dashboard.total1')
      this.tableTotal[1].name = this.$t('dashboard.total2')
      this.tableTotal[2].name = this.$t('dashboard.total3')
      this.tableLoading = true
      this.$get(`/UserIsp/Load?mealType=-1&page=1&limit=3`).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableData = res.data
        }
      })
      this.$get(`/UserIsp/IspAnlays`).then(res => {
        if (res.code === 200) {
          this.tableTotal[0].value = res.result.all
          this.tableTotal[1].value = res.result.exclusive
          this.tableTotal[2].value = res.result.shared
        }
      })
    }, 
    getHttpProxy (proxy) {
      let arr = proxy.split(':')
      if (arr.length = 4) {
        arr[1] = Number(arr[1]) + 1
      }
      return arr.join(':')
    }, 
    clickCopye (btn) {
      var clipboard = new this.Clipboard(`.${btn}`)
      clipboard.on('success', () => {
        this.$message.success(this.$t('reward.copySuccess'))
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.error(this.$t('reward.copyError'))
        clipboard.destroy()
      })
    },
    showQrCode (item) {
      this.$nextTick(() => {
        this.getQrCode(item.s5Proxy, item.id)
      })
    },
    getQrCode (proxy, id) {
      $(`#QRImg${id}`).html('')
      const proxySplit = proxy.split(':');
      let str = Base64.encode(`${proxySplit[2]}:${proxySplit[3]}@${proxySplit[0]}:${proxySplit[1]}`)
      let codeString = `socks://${str}?obfs=none`
      let qr = new QRCode(this.$refs[`QRImg${id}`], {width: 108, height: 108})
      qr.makeCode(codeString)
    },
    showEchart1 () {
      this.$get(`/usage/getbandwidth?mealType=2`).then(res => {
        if (res.code === 200) {
          this.cityList[0].value = Number((res.result.totalBandWidth / 1000000000).toFixed(2))
          this.cityList[1].value = Number((res.result.usedBandWidth / 1000000000).toFixed(2))
          this.cityList[2].value = Number(((res.result.totalBandWidth - res.result.usedBandWidth) / 1000000000).toFixed(2))
          this.showPie('echart2', this.cityList[2].value, this.cityList[1].value)
        }
      })
    },
    showEchart2 () {
      this.$get(`/usage/getbandwidth?mealType=1`).then(res => {
        if (res.code === 200) {
          this.countryList[0].value = Number((res.result.totalBandWidth / 1000000000).toFixed(2))
          this.countryList[1].value = Number((res.result.usedBandWidth / 1000000000).toFixed(2))
          this.countryList[2].value = Number(((res.result.totalBandWidth - res.result.usedBandWidth) / 1000000000).toFixed(2))
          this.showPie('echart1',  this.countryList[2].value, this.countryList[1].value)
        }
      })
    },
    showPie (id, value1, value2) {
      let option = {
        angleAxis: {
          max: 100,
          show: false,
          startAngle: -90,
          clockWise: false,
        },
        polar: {
          radius: ['84%', '92%'],
          center: ['50%', '50%'],
        },
        radiusAxis: {
          type: 'category',
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,

          },
          axisTick: {
            show: false
          },
        },
        series: [
          {
            name: '',
            type: 'pie',
            clockWise: false,
            hoverAnimation: false,
            radius: ['84%', '92%'],
            label: {show: false},
            data: [
              {name:'',value: value1, itemStyle:{
                borderRadius: 20,
                color:new echarts.graphic.LinearGradient(1,0,0,0,[{offset:0,color:'#FFB710'},{offset:1,color:'#FF6600'
              }])}},
              {name:'',value: value2, itemStyle:{color: 'rgba(0,0,0,0)'}},
            ],
          },
        ]
      }
      this[id] = echarts.init(document.getElementById(id))
      this[id].setOption(option)
    },
    showEchart3 () {   
      this.loadLineData = true
      this.$get(`/BandwidthStats/GetData?mealType=1`).then(res => {
        this.loadLineData = false
        if (res.code === 200) {
          let xData = []
          let yData1 = []
          res.result.map((val, idx) => {
            xData.push(`${idx < 10 ? '0' + idx : idx}:00`)
            yData1.push(Number((val / 1000000).toFixed(2)))
          }) 
          let option = {
            xAxis: {
              type: 'category',
              data: xData,
              boundaryGap:false,
              axisTick: { show: false, },
              axisLine: { show: true, color:'#7A7A7A'},
              axisLabel: {
                fontSize:14,
                color:'#7A7A7A'
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#EBEBEB',
                  type: 'dashed',
                }
              }
            },
            yAxis: {
              type: 'value',
              name: `流量[${this.echartUnit}]`,
              axisLabel: {
                fontSize:14,
                color:'#14110E',
              },
              nameTextStyle: {
                color:'#14110E',
                fontSize: 16,
                padding: [0,0,10,0]
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#EBEBEB',
                }
              }
            },
            series: [
              {
                data: yData1,
                type: 'line',
                showSymbol: true,
                smooth: true,
                symbolSize: 7,
                itemStyle: {
                  color: '#FF8F10',
                },
                emphasis: {
                  scale: 1.5,
                },
                areaStyle :{
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: 'rgba(255,143,16,0.2)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(255,143,16,0)'
                    }
                  ])
                },
                lineStyle: {
                  width: 3,
                  shadowBlur: 10,
                  shadowOffsetX: 4,
                  shadowOffsetY: 4,
                  shadowColor: 'rgba(255,143,16, 0.3)',
                  color: '#FF8F10'
                }
              }
            ],
            grid: {
              left: 100,
              right:18,
              top: 70,
              bottom: 30,
            },
            tooltip: {
              trigger: 'axis',
              show: true,
              formatter: (params) => {
                this.echartTime = params[0].name
                this.echartData = params[0].data
                return `<div class="toolTipBox">${this.echartData} <span class="unit">/${this.echartUnit}</span></div>`
              },
            }
          }
          this.echart3 = echarts.init(document.getElementById('echart3'));
          this.echart3.setOption(option);
        }
      })
    },
    clickBuy (type) {
      this.$router.push({path: '/purchaseTraffic', query: {type: type}})
    },
    initEvent () { // resize
      $(window).bind('resize', () => {
        if (this.echart1) this.echart1.resize();
        if (this.echart2) this.echart2.resize();
        if (this.echart3) this.echart3.resize();
      });
    },
    getTime (time) {
      return moment(time).format('YYYY-MM-DD') + '<br/>' + moment(time).format('HH:mm:ss')
    },
  },
  beforeDestroy () {
    // $(window).unbind('resize');
  },
  watch: {
    language () {
      this.getData()
    },
  },
  components: {miyaNumber, miyaBtn}
}
</script>
<style scoped lang="stylus">
.miya-dashboard
  min-width 900px
  height 100%
  .pageBox
    padding 40px 40px 0 40px
  .title1
    color $c1
    font-size 32px
    margin-bottom 42px
  .totalList
    display flex
    margin-bottom 58px
    .card-box
      flex 1
      &:nth-of-type(1)
        margin-right 3vw
      .title2
        display flex
        line-height 32px
        margin-bottom 32px
        position relative
        z-index 3
        .img
          width 32px
          margin-right 6px
        .titleString
          fontWeight()
          font-size $f18
          color $c1
          margin-right 24px
        .goPage
          font-size $f14
      .card
        display flex
        background: linear-gradient(270deg, #F5F6F7 0%, #FFFFFF 100%);
        border-radius 8px
        border 1px solid #EBEBEB
        margin-left 5vw
        .echart2
          min-width 122px
          min-height 122px
          width 10vw
          height 10vw
          margin-left -5vw
          position relative
          z-index 0
          #echart1, #echart2
            width 100%
            height 100%
            position relative
            z-index 3
          .img
            position absolute
            width 200%
            height 200%
            top -50%
            left -50% 
          .name, .value
            position absolute
            text-align center
            left 0
            width 100%
          .value
            top 36%
            font-size 28px
            color $c8
            fontWeight()
          .name
            top 60%
            width 80%
            left 50%
            line-height 18px
            transform translate3d(-50%, 0, 0)
            color $c1
            font-size $f14
        .dataList
          flex 1
          .item-box
            display flex
            height calc(100% - 60px)
            .item
              flex 1
              position relative
              text-align center
              display flex
              justify-content center
              flex-direction column
              &:nth-of-type(1):before
                content ''
                display block
                width 2px
                height 48px
                background-color #EBEBEB
                position absolute
                top 50%
                right 0
                transform translate3d(0, -50%, 0)
              .value
                color $c1
                font-size 28px
                margin-bottom 12px
              .name
                font-size $f14
                color $c2
          .btn-box
            padding 12px
            .btn
              line-height 36px
              padding 0 20px
              display inline-block
              color $c7
              font-size $f14
              margin-left 50%
              transform translate3d(-50%,0,0)
              background: linear-gradient(95deg, #FF8F10 0%, #FF7010 100%);
  .subtitle1
    font-size $f18
    color $c1
    fontWeight()
    display flex
    .time
      font-size $f16
      color $c2
      font-weight 300
      line-height 20px
      margin-left 14px
  .echar-box
    height 420px
    position relative
    margin-bottom 58px
    .data-box
      position absolute
      right 0
      top 0px
      display flex
      color $c1
      line-height 18px
      .time-box
        font-size $f14
        margin-right 16px
        text-align right
        .time
          font-size $f16
      .data
        font-size 40px
        line-height 36px
        margin-right 5px
      .unit
        font-size $f14
        color $c2
        line-height 52px
    .echart1
      height 100% 
      .empty
        padding-top 120px
        .nodata
          display block
          margin 0 auto
        .nodataText
          text-align center
          color $c2
          margin-top 24px
  .ivu-icon-ios-list-box-outline
    padding-top 20px
    margin-bottom 140px
  .list-box
    padding-bottom 42px
    .top-total
      color $c1
      display flex
      justify-content center
      margin-bottom 32px
      .item
        flex 1
        display flex
        justify-content left
        .icon
          width 26px
          height 26px
          margin-right 6px
        .name
          display flex
          font-size $f16
          margin 0 auto 12px auto
          line-height 26px
        .value
          font-size 28px
          .unit
            font-size $f14
            margin-left 4px
            color $c2
        &:nth-of-type(1)
          .icon
            background url('../../assets/images/home/all.png')
            background-size 100% 100%
        &:nth-of-type(2)
          .icon
            background url('../../assets/images/home/price-icon3.png')
            background-size 100% 100%
        &:nth-of-type(3)
            border-right none
          .icon
            background url('../../assets/images/home/price-icon4.png')
            background-size 100% 100%
    .bottom-table
      .subtitle2-box
        padding 0 0 24px 0
        justify-content space-between
        line-height 28px
        .more
          font-size $f14
      .qrcode
        color $c1
        font-size $f14
        background $c7
        padding 4px 16px
        position relative
        display inline-block
        border 1px solid #E0E0E0
        &:hover
          box-shadow: 0px 4px 8px 1px rgba(20,17,14,0.1);
      .type-name
        color $c1
        font-size $f14
        fontWeight()
        margin-bottom 6px
      .value-box
        width 240px
        line-height 24px
        color $c1
        font-size 16px
        display flex
        .icon
          width 24px
          height 24px
          background-image url(../../assets/images/home/price-icon3.png)
          background-size 100% 100%
          margin-right 8px
        .ispshare
          background-image url(../../assets/images/home/price-icon4.png)
          background-size 100% 100%
        .type
          fontWeight()
          color $c8
    .s5TextBox
      position relative
      .copyeBtnBox
        position absolute
        display none
        top 0
        left 0
        width 100%
        height 100%
        background-color rgba(255,251,245,0.6)
        animation moveIn .3s ease forwards
        .copyBtn
          position absolute
          top 50%
          left 50%
          transform translate3d(-50%, -50%, 0)
      &:hover
        .copyeBtnBox
          display block
.miya-dashboard-qr-img-box
  width 108px
@media screen and (max-width: 800px)
  .miya-dashboard
    min-width 100vw
    .title1
      margin-bottom 1rem
      line-height 1.5rem
    .totalList 
      display block
      margin-bottom 2rem
      .card-box
        &:nth-of-type(1)
          margin-right 0
          margin-bottom 1.8rem
        .title2
          margin-bottom 1rem
          .img
            width 1.2rem
            height 1.2rem
          .titleString
            font-size 0.7rem
            margin-right 0.5rem
          .goPage
            font-size 0.6rem
            padding 0 0.6rem
        .card
          .echart2
            min-width 5rem
            min-height 5rem
            width 5rem
            height 5rem
            .value
              top 1.5rem
              font-size 1rem
            .name
              top 2.4rem
              font-size 0.6rem
              line-height 0.8rem
          .dataList
            .item-box
              height calc(100% - 1.7rem)
              .item
                &:nth-of-type(1):before
                  height 2rem
                .value
                  font-size 1rem
                  margin-bottom 0.3rem
                .name
                  font-size 0.65rem
            .btn-box
              padding 0 0.5rem
              .btn
                margin-left 3rem
                font-size 0.6rem
                line-height 1.3rem
    .subtitle1, .subtitle1 .time
      line-height 1rem
      font-size 0.7rem
      margin-bottom 0.5rem
    .echar-box
      height 12rem
      .data-box
        .time-box
          font-size 0.65rem
          line-height 0.8rem
          .time
            font-size 0.8rem
        .data
          font-size 1.5rem
          line-height 1.8rem
        .unit
          line-height 2.2rem
          font-size 0.65rem
    .list-box
      .top-total
        flex-wrap wrap
        margin-bottom 0
        .item
          flex auto
          width 50%
          margin-bottom 1.5rem
          .icon
            width 1.2rem
            height 1.2rem
            margin-right 0.1rem
          .name
            font-size 0.8rem
            line-height 1.4rem
          .value
            font-size 1.5rem
            .unit
              font-size 0.7rem
      .bottom-table
        .subtitle2-box
          padding-bottom 1rem
          .more
            font-size 0.6rem
    .tableData
      width 900px
</style>
<style lang="stylus">
.miya-dashboard
  .el-table .cell
    padding-left 10px
    padding-right 10px
  .toolTipBox
    font-family "方圆","luxisr","Microsoft YaHei","微软雅黑",Arial,"Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB",sans-serif
    font-size $f18
    color $c1
    .unit
      font-size $f12
      color $c2
  .bottom-link
    background $c1
    .bottom-link-box
      width 100%
.el-popover
  min-width 100px
@media screen and (max-width: 800px)
  .miya-dashboard
    .el-table .cell
      padding-left 0.2rem
      padding-right 0.2rem
</style>